export const IS_PLAN_CONTAINER = 'IS_PLAN_CONTAINER'
export const MARKETING_PROPERTIES = 'MARKETING_PROPERTIES'
export const DEVICE_MODEL_SELECTION_REQUIRED = 'DEVICE_MODEL_SELECTION_REQUIRED'
export const PLAN_CATEGORY = 'PLAN_CATEGORY'
export const INDIVIDUAL_PLAN = 'INDIVIDUAL_PLAN'
export const FLAT_RATE_PLAN = 'FLAT_RATE_PLAN'
